import WhatIOwnAndWhereItIsKeptStyles from "./Styles";
import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import LogoIcon from "../../../../../css/WhiteLabelledDocuments/logo";
import WhereMyDocumentsMayBeFound from "./Components/WhereMyDocumentsMayBeFound";
import InsuranceAndDocumentDetails from "./Components/InsuranceDocumentDetails";
import MyWill from "./Components/MyWill";
import BankAccounts from "./Components/BankAccounts";
import CreditCardsSection from "./Components/CreditCards";
import EmployerDetails from "./Components/EmployerDetails";
import LifeAssurancePoliciesAndPensionPlans from "./Components/LifeAssurancePoliciesAndPensionPlans";
import InvesmentProperty from "./Components/InvestmentProperty";
import Investments from "./Components/Investments";
import UsefulContacts from "./Components/UsefulContacts";
import AssociationsClubsAndSocieties from "./Components/AssociationsClubsAndSocieties";
import Notes from "./Components/Notes";
import PdfHeader from "./Header";
import PdfFooter from "./Footer";
import PowerOfAttorney from "./Components/PowerOfAttorney";

const WhatIOwnAndWhereItIsKept = ({
  primaryColor = "081e56",
  logo,
  tradingName,
  regulatoryText,
  userEmail,
  userName,
}) => {
  const styles = WhatIOwnAndWhereItIsKeptStyles(primaryColor);
  return (
    <Document>
      <Page
        style={{
          ...styles.page,
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "space-between",
          // alignItems: "center",
          // flexWrap: "wrap",
        }}
      >
        <View style={styles.graphicWrapper}>
          <View style={styles.graphicBox} />
          <View style={styles.graphicBox1} />
          <View style={styles.graphicBox2} />
          <View style={styles.graphicBox3} />
        </View>
        <View style={styles.centeredContent}>
          {logo ? <Image style={styles.image} src={logo} /> : <LogoIcon />}
          {/* <LogoIcon /> */}
          {/* <Image style={styles.image1} src={LogoIcon} /> */}
          <Text style={styles.h3}>{tradingName}</Text>
          <View
            style={{
              ...styles.row,
              gap: 48,
              width: "100%",
              position: "absolute",
              bottom: -100,
              left: 0,
              right: 0,
              padding: 0,
            }}
          >
            <View style={{ ...styles.col, gap: 4, textAlign: "left" }}>
              <Text style={styles.ContentSmall}>
                What I Own and Where It Is Kept.
              </Text>
              <Text style={styles.LabelSmallItalic}>
                Deeds, insurance policies, share certificates, will, life
                assurance policy, etc.
              </Text>
            </View>
            <View style={{ ...styles.col, gap: 4, textAlign: "right" }}>
              <Text style={styles.LabelSmallSemiBold}>{userName}</Text>
              <Text style={styles.ButtonTextSmall}>{userEmail}</Text>
            </View>
          </View>
        </View>
        {/* <View>
        </View> */}
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter primaryColor={primaryColor} />
        <View style={{ ...styles.FlexStartColumn, gap: 48 }}>
          <WhereMyDocumentsMayBeFound
            primaryColor={primaryColor}
            logo={logo}
            tradingName={tradingName}
            regulatoryText={regulatoryText}
            userEmail={userEmail}
          />
          <InsuranceAndDocumentDetails
            primaryColor={primaryColor}
            logo={logo}
            tradingName={tradingName}
            regulatoryText={regulatoryText}
            userEmail={userEmail}
            userName={userName}
          />
        </View>
        {/* <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
        </View> */}
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter primaryColor={primaryColor} />
        <View style={{ ...styles.FlexStartColumn, gap: 38 }}>
          <MyWill primaryColor={primaryColor} />
          <BankAccounts primaryColor={primaryColor} />
          <CreditCardsSection primaryColor={primaryColor} />
        </View>
        {/* <View style={{ ...styles.FlexStartColumn }}>
        </View> */}
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter primaryColor={primaryColor} />
        <View style={{ ...styles.FlexStartColumn, gap: 38 }}>
          <EmployerDetails primaryColor={primaryColor} />
          <LifeAssurancePoliciesAndPensionPlans primaryColor={primaryColor} />
        </View>
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter primaryColor={primaryColor} />
        <View style={{ ...styles.FlexStartColumn, gap: 38 }}>
          <InvesmentProperty primaryColor={primaryColor} />
          <Investments primaryColor={primaryColor} />
        </View>
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter
          primaryColor={primaryColor}
          // regulatoryText={regulatoryText}
        />
        <View style={{ ...styles.FlexStartColumn, gap: 38 }}>
          <UsefulContacts primaryColor={primaryColor} />
          {/* <AssociationsClubsAndSocieties primaryColor={primaryColor} /> */}
        </View>
      </Page>
      <Page style={styles.page}>
        <PdfHeader logo={logo} primaryColor={primaryColor} />
        <PdfFooter
          primaryColor={primaryColor}
          regulatoryText={regulatoryText}
        />
        <View style={{ ...styles.FlexStartColumn, gap: 38 }}>
          <PowerOfAttorney
            primaryColor={primaryColor}
            logo={logo}
            tradingName={tradingName}
            regulatoryText={regulatoryText}
            userEmail={userEmail}
            userName={userName}
          />{" "}
          <Notes primaryColor={primaryColor} />
        </View>
      </Page>
    </Document>
  );
};

export default WhatIOwnAndWhereItIsKept;
